export default () => {
    let alertTrigger = document.querySelector('header.site-header .alert-bar button');
    let alertelement = document.querySelector("header.site-header .alert-bar");
    if(alertTrigger){
        alertTrigger.addEventListener('click', function (e) {
            e.preventDefault();
            if(alertelement.classList.contains('closed')){
            }
            else{
                alertelement.classList.add('closed');
            }
        });
    }
}